import makeRequest from "@/_services/ApiService";
import createRequestOptions from "./RequestOptions";
import store from "@/_store";
import { download } from "@/_utils/DownloadFile";
import { cleanupString } from "@/_utils/CleanupString";

const ProjectServices = () => {
  const requestOption = createRequestOptions();

  return {
    async METADATA(payload, update) {
      try {
        store.dispatch("changeLoadingState");
        await makeRequest(
          requestOption.POST(`v2/projects/metadata?update=${update}`, payload)
        ).then((response) => {
          store.dispatch("saveProjectData", response.data[0]);
          store.dispatch("changeLoadingState");
        });
      } catch (error) {
        store.dispatch("changeLoadingState");
        console.error(error);
        throw error;
      }
    },
    async UPDATE(payload, license) {
      store.dispatch("changeLoadingState");
      // Use background_task=true so the request returns immediately (202 Accepted)
      // and the heavy insert runs in the Celery worker. This avoids the nginx
      // timeout (504) that happens when the insert takes longer than the proxy timeout.
      try {
        const response = await makeRequest(
          requestOption.POST(
            `v2/projects/update_project?license=${license}&background_task=true`,
            payload
          )
        );
        store.dispatch("changeLoadingState");
        // The response is JSON with the Celery task_id (or a plain string from older code).
        let taskId = null;
        if (typeof response === "object" && response !== null && response.task_id) {
          taskId = response.task_id;
        }
        alert(
          "Update started in the background. You will be notified when it completes."
        );
        return { taskId };
      } catch (err) {
        alert(err);
        console.error(err);
        store.dispatch("changeLoadingState");
        throw err;
      }
    },
    async UPDATE_STATUS(projectCode, license, taskId) {
      try {
        let url = `v2/projects/update_status?project_code=${projectCode}&license=${license}`;
        if (taskId) {
          url += `&task_id=${taskId}`;
        }
        const response = await makeRequest(requestOption.GET(url));
        return response;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async UPLOAD_JSON(license, jsonContent) {
      try {
        // API endpoint with query parameters
        const endpoint = `v2/projects/import_json?license=${license}`;
        
        await makeRequest(
          requestOption.POST(
            endpoint,
            jsonContent,
              {
              headers: {
                "Content-Type": "application/json",
              },
            })          
        );
    
        console.log("Post request was sent to endpoint")
      } catch (error) {
        console.error("Error uploading JSON:", error);
        throw error;
      }
    },

    async DOWNLOAD_TERRAINDEX(payload, license, appcode) {
      store.dispatch("changeLoadingState");
      await makeRequest(
        requestOption.POST(
          `v2/terraindex/terra_project?license=${license}&appcode=${appcode}`,
          payload
        )
      )
        .then((response) => {
          const filename = cleanupString(payload.PrCode) + ".json";

          download(JSON.stringify(response), filename, "text/plain");
          store.dispatch("changeLoadingState");
        })
        .catch((err) => {
          console.error(err);
          store.dispatch("changeLoadingState");
        });
    },
    async UPLOAD_FILE(uuid, payload) {
      store.dispatch("changeLoadingState");
      await makeRequest(
        requestOption.PUT(`v2/projects/${uuid}/location`, payload)
      )
        .then((resp) => {
          console.log(resp);
          alert("Geometry updated");
          store.dispatch("saveGeometry", true);
          store.dispatch("changeLoadingState");
        })
        .catch((err) => {
          console.error(err);
          store.dispatch("changeLoadingState");
        });
    },
    async DELETE_PROJECT(uuid, reload) {
      reload = reload | "true";
      store.dispatch("changeLoadingState");
      console.log(`v2/projects/${uuid}/delete?reload=${reload}`);
      await makeRequest(
        requestOption.DELETE(`v2/projects/${uuid}/delete?reload=${reload}`)
      )
        .then((response) => {
          if (reload) {
            store.dispatch("saveProjectData", response.data[0]);
            alert("Project has been deleted and reloaded");
          } else {
            store.commit("RESET_STATE");
            alert("Project has been deleted and not updated");
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(store.dispatch("changeLoadingState"));
    }
  };
};

export default ProjectServices;
